import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex min-w-0 items-center rounded-none border px-2.5 py-0.5 text-xs font-mono tracking-[0.12em] transition-colors duration-100 ease-linear focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background",
  {
    variants: {
      variant: {
        default:
          "bg-foreground text-background border-foreground",
        secondary:
          "bg-secondary text-secondary-foreground border-border",
        destructive:
          "bg-destructive text-destructive-foreground border-destructive",
        outline: "bg-transparent text-foreground border-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
